/**
 * 解析 API 响应
 * @param {Object} response - API 响应
 * @returns {any} 解析后的数据
 * @throws {Error} 当请求失败时抛出错误
 */
export const parseResponse = response => {
  if (!response) {
    throw new Error('响应数据为空');
  }

  // 如果是包装的响应对象，则检查 success 和 code
  if (response.success !== true) {
    throw new Error(response.message || '请求失败：success 不为 true');
  }

  if (response.code !== 0) {
    throw new Error(response.message || `请求失败：错误码 ${response.code}`);
  }
  return response.data;
};
